import styled from "styled-components";

export const Wrapper = styled.div`
  input[type="number"] {
    -moz-appearance: textfield;
  }
`;
